import styled from 'styled-components'
import { breakpoint } from '@sketch/global-styles'
import { Text } from '@sketch/components'

import { ReactComponent as DividerSvg } from '@sketch/icons/dots-4-vertical-divider-32'

export const Divider = styled(DividerSvg)`
  width: 2px;
  height: 32px;
  margin-right: 8px;
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.background.tertiary.A};
`

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  position: fixed;
  right: 8px;
  top: 0;
  /* 68px is the height of the white bar that appears when we scroll down */
  height: 68px; /* stylelint-disable-line scales/space */
  left: calc(8px + var(--sidebar-width));

  ${breakpoint('base', 'sm')`
    padding: 8px;
    top: 0;
    /* 80px is the width of the Workspace selector and sidebar toggle button */
    left: 80px;
    right: 0;
    /* 48px is the size of the top navbar in mobile */
    height: 48px; /* stylelint-disable-line scales/space */
  `}
`

export const TopBannersSkeleton = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  width: 100%;
`

export const Actions = styled.div`
  display: flex;
  padding-right: 16px;
  justify-content: flex-end;
  flex: 1 0 auto;
  gap: 8px;

  /* Unfortunately, we need to override some styles here */
  /* https://github.com/sketch-hq/cloud-frontend/blob/8a8e91b032102a7de6f719111d8eeb366615bed5/packages/components/src/Header/Header.styles.ts#L161 */
  &&& button {
    margin: 0;
    height: 32px;
    padding: 10px 12px; /* stylelint-disable-line scales/space */
  }

  ${breakpoint('base', 'sm')`
    padding-right: 0px;
    gap: 8px;
  `}
`

export const ProfileStatus = styled.div`
  flex: 1 1 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 16px;
`

export const StyledText = styled(Text)`
  margin-left: 8px;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: ${({ theme }) => theme.fontSizes.D};
  /* To correctly vertically center the icon with the text */
  line-height: 1.4; /* stylelint-disable-line scales/line-heights */

  ${breakpoint('base', 'xxs')`
    display: none;
  `}
`
